import React from 'react';
import {ProprietarioObject} from "../../../models/Proprietario";
import FormProprietarioEmbed from "./FormProprietarioEmbed";
import ModalBody from "../../../components/Modal";
import {useAppDispatch} from "../../../lib/hooks";
import {actions} from "../../../lib/app";

interface FormProprietarioProps {
  instance?: ProprietarioObject;
  onSubmit: () => void;
}

const FormProprietario: React.FC<FormProprietarioProps> = (props) => {
  const {instance, onSubmit} = props;
  const dispatch = useAppDispatch();

  const onCompleteProprietario = (_prop: any) => {
    dispatch(actions.notifySuccess('Proprietário salvo com sucesso!'));
    // console.log('onCompleteProprietario', _prop);
    onSubmit()
  }

  return (
    <ModalBody>
      <FormProprietarioEmbed
        onComplete={onCompleteProprietario}
        instance={instance}
        state={instance ? 'cadastrar' : undefined}
      />
    </ModalBody>
  );
}

export default FormProprietario;
